import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { LangConstant } from "const";
import { CommonUtils } from "utils";

const EditAppDialog = ({ open, conference, onClose, onCreate, onUpdate }) => {
  const isEdit = Boolean(conference);
  const { t: getLabel } = useTranslation();

  const [form, setForm] = useState({
    conferenceId: conference?.id || "",
    name: conference?.name || "",
    description: conference?.description || "",
  });

  const handleChangeForm = event => {
    if (event.target.name === "name" || event.target.name === "description") {
      setForm(currentState => ({ ...currentState, [event.target.name]: CommonUtils.capitalizeFirstLetter(event.target.value) }));
    } else {
      setForm(currentState => ({ ...currentState, [event.target.name]: event.target.value }));
    }
  };

  const handleSubmit = () => {
    isEdit ? onUpdate(form) : onCreate(form);
  };

  useEffect(() => {
    if (open && conference) {
      setForm(currentState => ({
        ...currentState,
        conferenceId: conference?.id || "",
        name: conference?.name || "",
        description: conference?.description || "",
      }));
    } else {
      setForm(currentState => ({
        ...currentState,
        conferenceId: "",
        name: "",
        description: "",
      }));
    }
  }, [open, conference]);

  // ESC key handler
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = e => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal modal-blur fade show" style={{ display: "block" }} tabIndex="-1">
        <div className="modal-dialog modal-sm modal-dialog-centered" style={{ maxWidth: 600 }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                {getLabel("TXT_EDIT_APP_INFO")}
              </h5>
              <button className="btn btn-icon btn-ghost-secondary" onClick={onClose}>
                <IconX size={20} />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-column gap-3" style={{ padding: "8px 0" }}>
                <div>
                  <label className="form-label">{getLabel("TXT_FOLDER_NAME")} (*)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={getLabel("TXT_FOLDER_NAME")}
                    value={form.name}
                    name="folderName"
                    onChange={handleChangeForm}
                  />
                </div>
                <div>
                  <label className="form-label">{getLabel("TXT_DESCRIPTION")} (*)</label>
                  <textarea
                    className="form-control"
                    placeholder={getLabel("TXT_DESCRIPTION")}
                    value={form.description}
                    name="description"
                    onChange={handleChangeForm}
                    rows={4}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleSubmit}
                    disabled
                  >
                    {getLabel(isEdit ? LangConstant.TXT_EDIT_INFO : LangConstant.L_CREATE)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditAppDialog;
